/* eslint-disable @typescript-eslint/no-unused-vars */
import { Select, Switch } from 'antd';
import { useEffect, useState } from 'react';
import { updateDownLoad } from '../../../../api';
import { messageError, messageSuccess } from '../../../../components/message';
import { ModalWrap } from '../../../../components/modal-wrap';
import { getConfig } from '../../../../config';
import { wrapRequestArea } from '../../../../lib/http/lib';
import {
  getExtraManageSites,
  getFirstManageSite,
  getNeedManageSites,
  getSiteText,
} from '../../../../lib/multi-site';
import getFormatMessage from '../../../../locales/get-format-message';
import { DeployArea } from '../../../../model';
import { IDownLoadMenu } from '../../../../model/api-modules';
import { ISiteIDownLoadMenu, IStudioOptions } from '../download-items';
import styles from '../index.module.scss';

export type IStudioValues = Record<string, string[]>;

interface IProps {
  info: IDownLoadMenu;
  studioOptions: IStudioOptions;
  allSiteDownLoadList: ISiteIDownLoadMenu;
  onClose: () => void;
  onSave: () => void;
}

export const DownloadWhiteList = (props: IProps) => {
  const { info, allSiteDownLoadList, studioOptions, onSave, onClose } = props;
  const [turnOnSites, setTurnOnSites] = useState<string[]>([]);
  const [studioValues, setStudioValues] = useState<IStudioValues>({});
  const needManageSites = getNeedManageSites();

  useEffect(() => {
    init();
  }, [info]);

  const init = async () => {
    const currentValues: Record<string, string[]> = {};
    const currentWhites = info.StudioWhitelistArray || [];
    currentValues[getFirstManageSite()] = [...currentWhites];

    getExtraManageSites().forEach((otherSite) => {
      const matchedItem = getOtherSiteMatchItem(otherSite);
      currentValues[otherSite] = [...(matchedItem?.StudioWhitelistArray || [])];
    });

    setStudioValues(currentValues);
    setTurnOnSites(
      Object.keys(currentValues).filter(
        (site) => currentValues[site]?.length > 0
      ) as DeployArea[]
    );
  };

  const getOtherSiteMatchItem = (site: string) => {
    if (site === getFirstManageSite()) {
      return info;
    }
    return allSiteDownLoadList[site]?.find((item) => item.Name === info.Name);
  };

  const setTurnOnSite = (checked: boolean, site: string) => {
    setTurnOnSites(
      checked
        ? turnOnSites.concat(site)
        : turnOnSites.filter((item) => item !== site)
    );
    setStudioValues({ ...studioValues, [site]: [] });
  };

  const handleSelectChange = (values: string[], site: string) => {
    setStudioValues({ ...studioValues, [site]: values });
  };
  const submit = async () => {
    const res = await Promise.all(
      getNeedManageSites().map((needSite) => submitSite(needSite))
    );

    if (res.every(Boolean)) {
      messageSuccess(getFormatMessage('update_whitelist_success'));
      onSave();
      return true;
    }
    messageError(getFormatMessage('update_whitelist_fail'));
    return false;
  };

  const submitSite = async (site: string) => {
    const siteDownloadItem = getOtherSiteMatchItem(site);
    const isSiteTurnOn = turnOnSites.includes(site);
    const siteStudios = studioValues[site];
    if (isSiteTurnOn && !siteStudios?.length) {
      messageError(getFormatMessage('please_select_one_studio'));
      return false;
    }
    if (!siteDownloadItem) {
      return false;
    }

    const body = {
      Description: siteDownloadItem.Description,
      Name: siteDownloadItem.Name,
      Status: siteDownloadItem.Status,
      DocLink: siteDownloadItem.DocLink,
      StudioWhitelist: siteStudios || [],
    };

    const res = await wrapRequestArea(
      () => updateDownLoad(siteDownloadItem.id, body),
      site
    );
    return res;
  };

  const renderContent = (site: string) => {
    const isTurnOn = !!turnOnSites.includes(site);
    return (
      <div className={styles.whiteListContent}>
        {needManageSites.length > 1 && (
          <div className={styles.siteLabel}>{getSiteText(site)}:</div>
        )}
        <div>
          <span style={{ marginRight: '10px' }}>
            {getFormatMessage('turn_on')}
          </span>
          <Switch
            checked={isTurnOn}
            onChange={(checked) => setTurnOnSite(checked, site)}
          />
        </div>
        <div>
          <span>{getFormatMessage('studio_list')}</span>
          <Select
            options={studioOptions[site]}
            disabled={!isTurnOn}
            showSearch={true}
            optionFilterProp="label"
            mode="multiple"
            value={studioValues[site]}
            onChange={(values) => handleSelectChange(values, site)}
          />
        </div>
      </div>
    );
  };
  return (
    <ModalWrap
      onOk={submit}
      onClose={onClose}
      cancelText={getFormatMessage('cancel')}
      oKText={getFormatMessage('submit')}
      width="480px"
      title={getFormatMessage('white_list')}
      className="modal"
      maskClosable={true}
    >
      {needManageSites.map((site) => renderContent(site))}
    </ModalWrap>
  );
};
